/*! Vayrani Stilrosa PDP — gallery, variants, sticky ATC, shipping ETA, recently viewed */
(function () {
  'use strict';

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat);
    }
    var value = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR' }).format(value);
    } catch (e) {
      return '€' + value.toFixed(2).replace('.', ',');
    }
  }

  function addItemToCart(variantId, quantity) {
    var routes = window.Vayrani && window.Vayrani.routes;
    if (!routes || !routes.cartAdd) return Promise.reject(new Error('cart routes missing'));
    return fetch(routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity || 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return fetch(routes.cartJson, { headers: { Accept: 'application/json' } });
    }).then(function (r) { return r.json(); });
  }

  function updateCartCount(cart) {
    var count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = String(count);
    });
  }

  function openCartDrawer() {
    if (typeof window.VayraniOpenCartDrawer === 'function') {
      window.VayraniOpenCartDrawer();
      return;
    }
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    drawer.hidden = false;
    drawer.removeAttribute('inert');
    document.body.style.overflow = 'hidden';
  }

  function initGallery() {
    var gallery = document.querySelector('[data-pdp-gallery]');
    if (!gallery || gallery.dataset.bound === 'true') return;
    gallery.dataset.bound = 'true';

    var slides = gallery.querySelectorAll('[data-gallery-slide]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    var dots = gallery.querySelectorAll('[data-gallery-dot]');

    function getActiveIndex() {
      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i].classList.contains('is-active')) return i;
      }
      return 0;
    }

    function activateSlide(index) {
      var next = String(index);
      slides.forEach(function (slide) {
        slide.classList.toggle('is-active', slide.getAttribute('data-gallery-slide') === next);
      });
      thumbs.forEach(function (thumb) {
        thumb.classList.toggle('is-active', thumb.getAttribute('data-gallery-thumb') === next);
      });
      dots.forEach(function (dot) {
        dot.classList.toggle('is-active', dot.getAttribute('data-gallery-dot') === next);
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        activateSlide(thumb.getAttribute('data-gallery-thumb'));
      });
    });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        activateSlide(dot.getAttribute('data-gallery-dot'));
      });
    });

    var prevBtn = gallery.querySelector('[data-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-gallery-next]');
    if (prevBtn && slides.length > 1) {
      prevBtn.addEventListener('click', function () {
        var i = getActiveIndex();
        activateSlide(String(i === 0 ? slides.length - 1 : i - 1));
      });
    }
    if (nextBtn && slides.length > 1) {
      nextBtn.addEventListener('click', function () {
        var i = getActiveIndex();
        activateSlide(String(i === slides.length - 1 ? 0 : i + 1));
      });
    }

    var stage = gallery.querySelector('[data-pdp-gallery-stage]');
    if (stage && slides.length > 1) {
      var startX = 0;
      stage.addEventListener('touchstart', function (event) {
        startX = event.changedTouches[0].screenX;
      }, { passive: true });
      stage.addEventListener('touchend', function (event) {
        if (!window.matchMedia('(max-width: 749px)').matches) return;
        var diff = event.changedTouches[0].screenX - startX;
        if (Math.abs(diff) < 40) return;
        var i = getActiveIndex();
        activateSlide(String(diff < 0
          ? Math.min(i + 1, slides.length - 1)
          : Math.max(i - 1, 0)));
      }, { passive: true });
    }

    gallery._activateSlide = activateSlide;
  }

  function initProductForm() {
    var section = document.querySelector('[data-product-section]');
    if (!section || section.dataset.productFormBound === 'true') return;

    var jsonEl = section.querySelector('[data-product-json]');
    var form = section.querySelector('[data-product-form], form.pdp-form');
    if (!jsonEl || !form) return;
    section.dataset.productFormBound = 'true';

    var product;
    try {
      product = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    var variantInput = form.querySelector('[data-variant-id]');
    var addBtn = form.querySelector('[data-add-to-cart]');
    var priceEl = section.querySelector('[data-product-price]');
    var stickyPriceEl = document.querySelector('[data-sticky-price]');
    var stickyVariantEl = document.querySelector('[data-sticky-variant]');
    var stickyBtn = document.querySelector('[data-sticky-atc-btn]');
    var gallery = section.querySelector('[data-pdp-gallery]');

    function getSelectedOptions() {
      var fieldsets = Array.prototype.slice.call(form.querySelectorAll('[data-option-fieldset]'));
      fieldsets.sort(function (a, b) {
        return parseInt(a.getAttribute('data-option-index'), 10) - parseInt(b.getAttribute('data-option-index'), 10);
      });
      return fieldsets.map(function (fieldset) {
        var checked = fieldset.querySelector('[data-option-input]:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(options) {
      if (options.some(function (v) { return v === null; })) return null;
      return product.variants.find(function (variant) {
        return variant.options.every(function (opt, i) { return opt === options[i]; });
      }) || null;
    }

    function renderPrice(variant) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        return '<div class="price price--on-sale"><s class="price__compare">' + formatMoney(variant.compare_at_price) +
          '</s> <span class="price__sale">' + formatMoney(variant.price) + '</span></div>';
      }
      return '<div class="price"><span class="price__regular">' + formatMoney(variant.price) + '</span></div>';
    }

    function syncLabels() {
      form.querySelectorAll('[data-option-fieldset]').forEach(function (fieldset) {
        var checked = fieldset.querySelector('[data-option-input]:checked');
        var pos = fieldset.getAttribute('data-option-index');
        var current = fieldset.querySelector('[data-option-current="' + pos + '"]');
        fieldset.querySelectorAll('.pdp-form__value, .pdp-form__swatch').forEach(function (label) {
          var input = label.querySelector('input');
          label.classList.toggle('is-selected', !!(input && input.checked));
        });
        if (checked && current) current.textContent = checked.value;
      });
    }

    function activateMedia(mediaId) {
      if (!gallery || !mediaId) return;
      var slides = gallery.querySelectorAll('[data-gallery-slide]');
      var matchIndex = null;
      slides.forEach(function (slide) {
        if (String(slide.getAttribute('data-media-id')) === String(mediaId)) {
          matchIndex = slide.getAttribute('data-gallery-slide');
        }
      });
      if (matchIndex != null && gallery._activateSlide) gallery._activateSlide(matchIndex);
    }

    function updateVariant(variant) {
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      var priceHtml = renderPrice(variant);
      if (priceEl) priceEl.innerHTML = priceHtml;
      if (stickyPriceEl) stickyPriceEl.innerHTML = priceHtml;
      if (stickyVariantEl) stickyVariantEl.textContent = variant.title || '';
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'In den Warenkorb' : 'Ausverkauft';
      }
      if (stickyBtn) {
        stickyBtn.disabled = !variant.available;
        stickyBtn.textContent = variant.available ? 'In den Warenkorb' : 'Ausverkauft';
      }
      if (variant.featured_media && variant.featured_media.id) {
        activateMedia(variant.featured_media.id);
      } else if (variant.featured_image && variant.featured_image.id) {
        activateMedia(variant.featured_image.id);
      }
      syncLabels();
    }

    form.addEventListener('change', function (event) {
      if (!event.target.matches('[data-option-input]')) return;
      var variant = findVariant(getSelectedOptions());
      if (variant) updateVariant(variant);
      else syncLabels();
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var variant = findVariant(getSelectedOptions()) || product.variants.find(function (v) {
        return String(v.id) === String(variantInput && variantInput.value);
      });
      if (!variant || !variant.available) return;
      var qtyInput = form.querySelector('[name="quantity"]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      if (addBtn) addBtn.disabled = true;
      addItemToCart(variant.id, qty)
        .then(function (cart) {
          updateCartCount(cart);
          openCartDrawer();
        })
        .catch(function () {
          form.submit();
        })
        .finally(function () {
          if (addBtn) {
            addBtn.disabled = false;
            addBtn.textContent = 'In den Warenkorb';
          }
        });
    });

    var initial = findVariant(getSelectedOptions()) || product.variants[0];
    if (initial) updateVariant(initial);
  }

  function initStickyAtc() {
    var sticky = document.querySelector('[data-sticky-atc]');
    var submit = document.querySelector('.pdp-form__submit');
    if (!sticky || !submit) return;

    if (sticky.parentElement !== document.body) {
      document.body.appendChild(sticky);
    }

    if (window.matchMedia('(min-width: 750px)').matches) {
      sticky.hidden = true;
      return;
    }

    if (sticky.dataset.bound === 'true') return;
    sticky.dataset.bound = 'true';

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        sticky.hidden = entry.isIntersecting;
      });
    }, { threshold: 0 });
    observer.observe(submit);
    sticky.hidden = true;
  }

  function initPdpShippingBar() {
    document.querySelectorAll('[data-pdp-shipping-bar]').forEach(function (bar) {
      var currency = (
        (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
        bar.getAttribute('data-market-currency') ||
        'EUR'
      ).toUpperCase();
      var isCh = currency === 'CHF' || bar.getAttribute('data-market-key') === 'ch';
      var marketKey = isCh ? 'ch' : 'de';

      bar.setAttribute('data-market-key', marketKey);
      bar.setAttribute('data-market-currency', currency);

      var flagNode = bar.querySelector('[data-market-flag]');
      if (flagNode) flagNode.textContent = isCh ? '🇨🇭' : '🇩🇪';

      var labelNode = bar.querySelector('[data-market-ship-label]');
      if (labelNode) {
        labelNode.textContent = isCh ? 'Kostenlos nach CH' : 'Kostenlos nach DE';
      }

      var trustShip = document.querySelector('[data-market-trust-ship]');
      if (trustShip) {
        trustShip.textContent = isCh
          ? 'Schweiz · kein Mindestbestellwert'
          : 'Deutschland · kein Mindestbestellwert';
      }

      var dateNode = bar.querySelector('[data-ship-date]');
      if (!dateNode || dateNode.dataset.ready === 'true') return;
      dateNode.dataset.ready = 'true';

      var months = ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'];

      function addBusinessDays(fromDate, count) {
        var date = new Date(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate());
        var added = 0;
        while (added < count) {
          date.setDate(date.getDate() + 1);
          var weekday = date.getDay();
          if (weekday !== 0 && weekday !== 6) added += 1;
        }
        return date;
      }

      function formatDayMonth(date) {
        return date.getDate() + ' ' + months[date.getMonth()];
      }

      var today = new Date();
      var start = addBusinessDays(today, 1);
      var end = addBusinessDays(today, 3);

      if (start.getMonth() === end.getMonth()) {
        dateNode.textContent = start.getDate() + '–' + end.getDate() + ' ' + months[end.getMonth()];
      } else {
        dateNode.textContent = formatDayMonth(start) + ' – ' + formatDayMonth(end);
      }
    });
  }

  var RECENTLY_VIEWED_KEY = 'vayrani:recently-viewed';

  function readRecentlyViewed() {
    try {
      return JSON.parse(localStorage.getItem(RECENTLY_VIEWED_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function writeRecentlyViewed(items) {
    try {
      localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(items.slice(0, 12)));
    } catch (e) { /* ignore */ }
  }

  function trackRecentlyViewedProduct() {
    var node = document.querySelector('[data-recently-viewed-product]');
    if (!node) return;
    var product;
    try {
      product = JSON.parse(node.textContent);
    } catch (e) {
      return;
    }
    if (!product || !product.handle) return;
    var items = readRecentlyViewed().filter(function (item) {
      return item && item.handle && item.handle !== product.handle;
    });
    items.unshift(product);
    writeRecentlyViewed(items);
  }

  function renderRecentlyViewed() {
    var section = document.querySelector('[data-recently-viewed]');
    if (!section) return;
    var grid = section.querySelector('[data-recently-viewed-grid]');
    if (!grid) return;
    var currentHandle = section.getAttribute('data-current-handle') || '';
    var limit = parseInt(section.getAttribute('data-limit') || '4', 10) || 4;
    var items = readRecentlyViewed().filter(function (item) {
      return item && item.handle && item.handle !== currentHandle && item.url;
    }).slice(0, limit);

    if (!items.length) {
      section.hidden = true;
      grid.innerHTML = '';
      return;
    }
    section.hidden = false;
    grid.innerHTML = items.map(function (item) {
      var title = String(item.title || '').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      var price = String(item.price || '').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      var alt = String(item.alt || item.title || '').replace(/"/g, '&quot;');
      return '<a class="pdp-recent__card" href="' + item.url + '">' +
        (item.image
          ? '<span class="pdp-recent__media"><img src="' + item.image + '" alt="' + alt + '" loading="lazy" width="400" height="500"></span>'
          : '<span class="pdp-recent__media" aria-hidden="true"></span>') +
        '<span class="pdp-recent__title">' + title + '</span>' +
        (price ? '<span class="pdp-recent__price">' + price + '</span>' : '') +
        '</a>';
    }).join('');
  }

  function initRecentlyViewed() {
    trackRecentlyViewedProduct();
    renderRecentlyViewed();
  }

  function initSizeGuideModal() {
    var modal = document.querySelector('[data-size-guide-modal]');
    if (!modal) return;
    document.querySelectorAll('[data-size-guide-open]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
      });
    });
    modal.querySelectorAll('[data-size-guide-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        modal.hidden = true;
        document.body.style.overflow = '';
      });
    });
  }

  function init() {
    initGallery();
    initProductForm();
    initStickyAtc();
    initSizeGuideModal();
    initRecentlyViewed();
    initPdpShippingBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
